"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATABASE_DELETED_COLUMNS_PROP = void 0;
exports.normalizeDatabaseDeletedColumns = normalizeDatabaseDeletedColumns;
exports.removableDeletedColumnIds = removableDeletedColumnIds;
exports.undefinedDeletedColumns = undefinedDeletedColumns;
const database_large_data_policy_1 = require("./database-large-data-policy");
/** Root block property holding the deleted columns of a database. */
exports.DATABASE_DELETED_COLUMNS_PROP = 'prop:deletedColumns';
/** Reads the stored value defensively: peers may write anything. */
function normalizeDatabaseDeletedColumns(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return {};
    const deleted = {};
    for (const [columnId, deletedAt] of Object.entries(value)) {
        if (typeof deletedAt === 'number' && Number.isFinite(deletedAt))
            deleted[columnId] = deletedAt;
    }
    return deleted;
}
/**
 * The columns whose leftover cells a row write removes.
 *
 * The definition and the row shards synchronize independently, so a cell
 * without a defined column may belong to a column this device has not received
 * yet. Only a column listed as deleted is removable, and only once the
 * retention has passed: until then undo brings the column back with every
 * value. A column that is defined again is never removable, whatever the list
 * says.
 */
function removableDeletedColumnIds(input) {
    const retentionMs = input.retentionMs ??
        database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.column.deletedCellRetentionMs;
    const defined = new Set(input.definedColumnIds);
    const removable = new Set();
    for (const [columnId, deletedAt] of Object.entries(input.deletedColumns)) {
        if (defined.has(columnId))
            continue;
        if (input.now - deletedAt >= retentionMs)
            removable.add(columnId);
    }
    return removable;
}
/**
 * The deleted columns a database no longer defines, with the time each was
 * deleted. Search hides them at once and shows them again when undo defines
 * them again; their indexed cells leave once removableDeletedColumnIds lists
 * them.
 */
function undefinedDeletedColumns(input) {
    const defined = new Set(input.definedColumnIds);
    return Object.fromEntries(Object.entries(input.deletedColumns)
        .filter(([columnId]) => !defined.has(columnId))
        .sort(([left], [right]) => (left < right ? -1 : left > right ? 1 : 0)));
}
